var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All Icon",
    clipPath: "url(#clip0_5418_76350)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7109 2.80018V3.53887H14.7874V1.50064C14.7874 1.20338 14.5464 0.962402 14.2492 0.962402H12.2109V2.03887H12.9499L9.74976 5.239L7.13033 2.61959C6.92014 2.4094 6.57935 2.4094 6.36916 2.61959L3.5189 5.46985L4.28007 6.23103L6.74975 3.76136L9.36918 6.38078C9.57936 6.59096 9.92017 6.59096 10.1303 6.38077L13.7109 2.80018Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46163 8.47639V7.7124H9.5381V8.47648L9.73084 8.49386C13.8272 8.86336 17.0374 12.3066 17.0374 16.4993C17.0374 16.7965 16.7964 17.0375 16.4992 17.0375H1.49917C1.20191 17.0375 0.960938 16.7965 0.960938 16.4993C0.960938 12.3061 4.17181 8.8626 8.26885 8.49374L8.46163 8.47639ZM2.07989 15.726L2.05391 15.961H8.92727L8.93533 15.5376C8.04675 15.5038 7.33663 14.7726 7.33663 13.8756C7.33663 13.1939 7.74678 12.6076 8.33465 12.3507L8.46163 12.2952V9.55394L8.22662 9.5799C4.99904 9.93635 2.43666 12.4985 2.07989 15.726ZM9.77315 9.58005L9.5381 9.55404V12.2952L9.66508 12.3507C10.2529 12.6076 10.6631 13.1939 10.6631 13.8756C10.6631 14.7726 9.95298 15.5038 9.0644 15.5376L9.07245 15.961H15.9445L15.9185 15.726C15.5617 12.4989 13.0001 9.9371 9.77315 9.58005ZM8.99986 13.2889C8.67583 13.2889 8.4131 13.5516 8.4131 13.8756C8.4131 14.1997 8.67583 14.4624 8.99986 14.4624C9.32389 14.4624 9.58663 14.1997 9.58663 13.8756C9.58663 13.5516 9.32389 13.2889 8.99986 13.2889Z",
    fill: "#F6F6F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5418_76350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.2c16b1d4ed1405349ef83f9d6cea8331.svg";
export { ForwardRef as ReactComponent };